import { createContext, useContext } from 'react';

export type CurrentAdmin = {
  id: string;
  email: string;
  createdAt: string;
  lastLoginAt?: string | null;
};

export type AuthContextValue = {
  /** The bearer token, or `null` when signed out. */
  token: string | null;
  /** `adminMe`, once it has answered. */
  admin: CurrentAdmin | null;
  /** True while the boot-time `adminMe` is in flight. */
  hydrating: boolean;
  signIn: (accessToken: string) => void;
  signOut: () => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);

  if (!value) throw new Error('useAuth must be used inside <AuthProvider>');

  return value;
}
